export const categories = [
  {
    slug: 'bladder-health',
    name: '膀胱健康',
    description: '了解膀胱结构与功能，掌握泌尿系统健康基础知识，预防常见膀胱疾病，守护排尿健康。',
    icon: 'ri-mental-health-line',
  },
  {
    slug: 'training-methods',
    name: '训练方法',
    description: '科学的膀胱训练技巧与盆底肌锻炼方案，帮助改善膀胱控制能力，提升生活质量。',
    icon: 'ri-heart-pulse-line',
  },
  {
    slug: 'diet-nutrition',
    name: '饮食调理',
    description: '通过合理饮食调节膀胱功能，了解哪些食物有益、哪些需要避免，从日常饮食入手呵护泌尿健康。',
    icon: 'ri-restaurant-line',
  },
  {
    slug: 'daily-care',
    name: '日常保健',
    description: '日常生活习惯与膀胱健康的密切关系，从饮水、作息到运动，全方位守护泌尿系统。',
    icon: 'ri-sun-line',
  },
];